import { IConfig } from '@cian/config/shared';
import { getWebview } from '@cian/webview/webview';

export function sendWebviewInitAction(config: IConfig): void {
  if (config.get<boolean>('web.isWebView')) {
    getWebview().sendAction({ action: '@@APP-INIT' });
  }
}
